import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ErrorMessageUtils } from '../../utils/ErrorMessageUtils';
import { AlertSeverity } from '../../ui/alert.component';

import { AlertComponent } from '../../ui/alert.component';
import { CardComponent } from '../../ui/card.component';
import { ButtonDirective } from '../../ui/button.directive';
import { InputDirective } from '../../ui/input.directive';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
@Component({
  // `display: block` on the host: an Angular component element is inline by default,
  // and Tailwind's space-y-* sets margin-top, which does nothing on an inline box. As
  // an inline host this rendered with no vertical gap at all between siblings.
  host: { class: 'block' },
  selector: 'app-trial-upgrade',
  templateUrl: './trial-upgrade.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AlertComponent,
    CardComponent,
    ButtonDirective,
    InputDirective,
    AsyncPipe,
    ReactiveFormsModule,
  ],
})
export class TrialUpgradeComponent {
  // Only trial accounts see the upgrade prompt; it clears the moment trial flips to false.
  isTrial$: Observable<boolean> = this.authService.user$.pipe(
    map((user) => user?.trial === true),
  );

  chipnumber = new FormControl('', [Validators.required]);
  inSubmission: boolean = false;
  showAlert: boolean = false;
  severity: AlertSeverity = 'info';
  message: string = '';
  // Keeps the confirmation visible after the upgrade flips trial to false and would
  // otherwise unmount the banner immediately.
  upgraded: boolean = false;

  constructor(private authService: AuthService) {}

  async upgrade(): Promise<void> {
    if (this.chipnumber.invalid || this.inSubmission) {
      return;
    }
    this.inSubmission = true;
    try {
      await this.authService.upgradeTrialUser(this.chipnumber.value ?? '');
      this.upgraded = true;
      this.showAlert = true;
      this.severity = 'success';
      this.message = 'Je bent nu volwaardig lid. Veel spinplezier!';
      this.chipnumber.reset();
    } catch (error) {
      this.showAlert = true;
      this.severity = 'error';
      this.message =
        ErrorMessageUtils.determineFrontendMessageBasedOnError(error);
    } finally {
      this.inSubmission = false;
    }
  }
}
